import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActionButton} from "../../../model/ui/action-button";
import {SelectItem} from "primeng/api";
import {Template} from "../../../model/template";
import {TemplateFilters} from "../../../model/filters/template-filters";
import {TemplatesService} from "../../../services/templates.service";
import {SortOrder} from "../../../model/sort-order";
import {DeviceCategory} from "../../../model/device-category";
import {Tenant} from "../../../model/tenant";
import {TenantsService} from "../../../services/tenants.service";
import {AuthGuard} from "../../../common/auth-guard.service";

@Component({
  selector: 'app-template-selector',
  templateUrl: './template-selector.component.html',
  styleUrls: ['./template-selector.component.scss']
})
export class TemplateSelectorComponent {

  readonly DEFAULT_SORT_FIELD = 'name';
  readonly DEFAULT_SORT_ORDER = 1;

  @Input() type: string;
  @Input() tenant: Tenant;
  @Input() actionButtons: ActionButton[];

  @Output() visibleChange: EventEmitter<boolean>;

  dialogVisible: boolean;
  templates: Template[];
  totalTemplates: number;
  loadingTemplates: boolean;

  first: number;
  rows: number;

  deviceCategories: SelectItem<string>[];
  currentFilters: TemplateFilters;
  selectedTemplate: Template;

  hasBeenOpened: boolean;

  constructor(private tenantsService: TenantsService,
              private templatesService: TemplatesService,
              public authGuard: AuthGuard) {
    this.visibleChange = new EventEmitter<boolean>();
    this.first = 0;
    this.rows = 10;
    this.currentFilters = new TemplateFilters();
    this.currentFilters.sortField = this.DEFAULT_SORT_FIELD;
    this.currentFilters.sortOrder = this.DEFAULT_SORT_ORDER;
    this.loadingTemplates = false;
    this.hasBeenOpened = false;
    this.templates = new Array(this.rows);
  }

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
    if (visible && !this.hasBeenOpened) {
      this.hasBeenOpened = true;
      this.loadTemplates(0, this.rows);
      this.loadData();
    }
  }

  loadData(): void {
    this.currentFilters.tenantUuids = [this.tenant.uuid];
    this.currentFilters.types = [this.type];
    if (this.type === 'DEVICE') {
      this.loadDeviceCategories();
    }
  }

  applyFilters(): void {
    this.first = 0;
    this.loadTemplates(this.first / this.rows, this.rows);
  }

  onTemplatePageChange(event: any): void {
    if (this.hasBeenOpened) {
      this.currentFilters.sortField = event.sortField;
      this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      this.loadTemplates(event.first / event.rows, event.rows);
    }
  }

  private loadTemplates(offset: number, limit: number): void {
    this.loadingTemplates = true;
    this.currentFilters.tenantUuids = [this.tenant.uuid];
    this.currentFilters.types = [this.type];
    this.templatesService.getTemplates(offset, limit, this.currentFilters).subscribe(response => {
      this.templates = response.templates;
      this.totalTemplates = response.totalElements;
      this.loadingTemplates = false;
    });
  }

  private loadDeviceCategories(): void {
    this.tenantsService.getTenantDeviceCategories(this.tenant.uuid).subscribe(response => {
      const categoryNames: string[] = response.deviceCategories
        .map((category: DeviceCategory) => category.name);
      const uniqueCategoryNames = [...new Set(categoryNames)];
      this.deviceCategories = uniqueCategoryNames.sort()
        .map((value: string) => ({value}));
    });
  }

}
